export enum MouseButtons {
  Left = 1,
  Right = 2,
  Middle = 4,
}
export enum MouseButton {
  Left,
  Middle,
  Right,
  Back,
  Forward,
}
